const faqs = [
  {
    q: '亲亲漫画网是完全免费的吗？',
    a: '是的，亲亲漫画网所有漫画全集均为免费阅读，无需付费或订阅。我们致力于为漫画爱好者提供零门槛的全集在线阅读体验，下拉式阅读模式让您流畅浏览全部章节。',
  },
  {
    q: '什么下拉式全集阅读？',
    a: '下拉式全集阅读是一种创新的浏览方式，您无需点击翻页按钮，只需向下滑动即可连贯阅读漫画全部章节。所有完结漫画都支持此模式，让您一次性看完整部作品，体验极佳。',
  },
  {
    q: '网站支持哪些漫画类型？',
    a: '亲亲漫画网收录日漫全集和韩漫全集两大类。涵盖热血、恋爱、奇幻、悬疑、搞笑、校园、都市等多种题材，主打完结漫画大全，让您不必追更等待。',
  },
  {
    q: '如何找到想看的完结漫画？',
    a: '您可以通过首页的专题合集、热门榜单和话题标签快速发现喜欢的作品。我们按热度、更新时间和类型精心分类，搜索和浏览都非常方便。',
  },
  {
    q: '漫画更新频率怎么样？',
    a: '亲亲漫画网每日更新超过200个章节，热门连载第一时间同步。完结作品也会持续补充入库，确保漫画大全内容日益丰富，满足不同读者的需求。',
  },
  {
    q: '支持手机和电脑阅读吗？',
    a: '完全支持！亲亲漫画网针对桌面端和移动端都进行了优化，无论使用电脑、平板还是手机，都能享受流畅的下拉式全集阅读体验，随时随地看漫画。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          常见问答
        </h2>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-100 group-open:text-primary-600 text-foreground-400 transition-colors flex-shrink-0">
                  <i className="ri-add-line group-open:ri-subtract-line text-sm"></i>
                </span>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}